import { faSortAlphaDown, faSortAlphaUp, faSortNumericDown, faSortNumericUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { CSSProperties, ReactNode, useContext } from 'react';
import TableSortContext from '../TableSortContext';
import { TSortType } from '../useTableSort';



interface IProps {
  children: ReactNode;
  sort?: string;
  numeric?: boolean;
  type?: TSortType;
  style?: CSSProperties;
}

const TableTh: React.FC<IProps> = ({ children, sort, numeric, type = "string", style }) => {
  const { onSort, sort: contextSort } = useContext(TableSortContext);


  const classNames = [];
  if (sort) {
    classNames.push('pointer');
  }

  let iconUp = faSortAlphaUp;
  let iconDown = faSortAlphaDown;

  if(numeric) {
    iconUp = faSortNumericUp;
    iconDown = faSortNumericDown;
  }

  return (
    <th
      className={classNames.join(" ")}
      onClick={sort ? () => onSort(sort, type) : undefined}
      style={style}
    >
      {children}
      {sort && sort === contextSort.key && (
        <FontAwesomeIcon
          style={{ marginLeft: '.25rem' }}
          icon={contextSort.reverse ? iconUp : iconDown}
        />
      )}
    </th>
  );
}

export default TableTh;